module.exports = __webpack_public_path__ + "img/pricing-platinum.06957117.png";